import gql from 'graphql-tag';

const CREATE_ORG = gql`
  mutation createOrg(
    $name: String!
    $description: String
    $website: String!
    $domain: String
    $platformDomain: String
    $tagDomain: String
    $level: PartnerLevel!
    $logoId: MediaCreateOneWithoutOrgInput
    $parentOrgs: [OrgWhereUniqueInput!]
    $roleitems: [RoleItemCreateWithoutRoleInput!]
    $config: OrgConfigCreateWithoutOrgsInput
    $reTargeting: Boolean!
    $appIds: [String!]
    $tradeDeskIdentifier: String
    $storageBucket: String
    $googleCustomerId: String
    $signInLogoId: MediaCreateOneInput
    $viewId: String
    $seo: Boolean!
    $semrushEnable: Boolean
    $projectId: String
    $rootDomainUrl: String
    $rootKeyword: String
    $competitor1stRootDomainUrl: String
    $competitor2ndRootDomainUrl: String
    $chatWootId: String
    $cpm: String
    $isGA4: Boolean
    $CPAcronym: String
  ) {
    createOrg(
      data: {
        name: $name
        description: $description
        website: $website
        domain: $domain
        platformDomain: $platformDomain
        tagDomain: $tagDomain
        logo: $logoId
        signInLogo: $signInLogoId
        level: $level
        chatWootId: $chatWootId
        cpm: $cpm
        CPAcronym: $CPAcronym
        parentOrg: { connect: $parentOrgs }
        config: { create: $config }
        dataConfig: {
          create: {
            reTargeting: $reTargeting
            appIds: { set: $appIds }
            tradeDeskIdentifier: $tradeDeskIdentifier
            storageBucket: $storageBucket
            googleCustomerId: $googleCustomerId
            seo: $seo
            semrushEnable: $semrushEnable
            semrushConfig: {
              create: {
                projectId: $projectId
                rootDomainUrl: $rootDomainUrl
                rootKeyword: $rootKeyword
                competitor1stRootDomainUrl: $competitor1stRootDomainUrl
                competitor2ndRootDomainUrl: $competitor2ndRootDomainUrl
              }
            }
            googleAnalytics: { create: { viewId: $viewId, isGA4: $isGA4 } }
          }
        }
        roles: { create: { name: $name, roleItems: { create: $roleitems }, isMaster: true } }
      }
    ) {
      id
      brands(first: 5) {
        name
        logo {
          key
        }
      }
      config {
        priceVisible
        isAdmin
        isPartner
        isTrafficker
        exportData
        isSelfService
        hasInsights
        providersVisible
        isProcessor
        canResetPasswords
        campaignSummary
        isPacing
        pastData
        segment
        articles
        amplify
        configurator
        billing
        sitesAppsTransactions
      }
      dataConfig {
        reTargeting
        appIds
        tradeDeskIdentifier
        storageBucket
        googleCustomerId
        seo
        semrushEnable
        semrushConfig {
          projectId
          rootDomainUrl
          rootKeyword
          competitor1stRootDomainUrl
          competitor2ndRootDomainUrl
        }
        googleAnalytics {
          viewId
          isGA4
        }
      }
      name
      description
      locations(first: 5) {
        street
        city
        state
      }
      logo {
        id
        key
      }
      signInLogo {
        id
        key
      }
      roles(first: 5) {
        id
        name
        isMaster
        roleItems(first: 10) {
          id
          feature
          actions
        }
        users {
          id
        }
      }
      level
      website
      domain
      platformDomain
      tagDomain
      parentOrg {
        name
        id
      }
      chatWootId
      cpm
      CPAcronym
    }
  }
`;

export default CREATE_ORG;
